{
  "schemaVersion": 1,
  "id": "offset-grid-joints",
  "version": "1.0",
  "name": "Offset grid: full-width shelves, short dividers housed above and below, full-height sides",
  "family": "offset-grid",
  "familyId": "offset-grid",
  "jointFamily": "mixed",
  "provisional": true,
  "reviewer": null,
  "reviewedAt": null,
  "selfAuthored": true,
  "author": "David Mansaray",
  "authoredAt": "2026-10-09",
  "sources": [
    "research/taxonomy.md §1.3 Offset grid: short dividers housed into the shelves above and below; open backs need housings rather than butt dowels; dividers spaced to meet the span limit",
    "PLAN.md §5: housed dado one third of the thickness deep; egg-crate halving; rebate for backs; glue-ups from boards up to maxWidth",
    "Grid bookcase joints.json (fasteners, wall fixing, anti-tip, tolerances) carried over"
  ],
  "joint": "Two full-height sides with a top and a bottom; full-width shelves housed one third of the thickness into the sides; short dividers between consecutive shelves at positions that change row to row, housed into the shelf above and below (dowelled when a full back carries the racking).",
  "joints": [
    {
      "at": "bottom-side",
      "kind": "screwed-butt",
      "params": {
        "screwSpec": "4.0 × 50 mm countersunk"
      }
    },
    {
      "at": "top-side",
      "kind": "screwed-butt",
      "params": {
        "screwSpec": "4.0 × 50 mm countersunk"
      }
    },
    {
      "at": "shelf-side",
      "kind": "housed-dado",
      "params": {
        "depthRatio": 0.3333
      },
      "note": "Full-width shelves housed into the sides."
    },
    {
      "at": "divider-shelf",
      "kind": "housed-dado",
      "params": {
        "depthRatio": 0.3333
      },
      "note": "Short dividers housed into the shelf above and below; dowel-butt only with a full back."
    },
    {
      "at": "back-carcass",
      "kind": "screwed-butt",
      "params": {
        "screwSpec": "3.5 × 20 mm pan head"
      },
      "note": "Full back, or a small back in each chosen cell fitted between its shelves and dividers."
    }
  ],
  "envelope": {
    "W": {
      "min": 5000,
      "max": 24000
    },
    "H": {
      "min": 6000,
      "max": 22000
    },
    "D": {
      "min": 1200,
      "max": 4500
    },
    "n": {
      "min": 1,
      "max": 10
    },
    "minOpeningTicks": 1500
  },
  "limits": {
    "maxSpanMm": 800,
    "minOpeningMm": 150
  },
  "edgeAllowanceTicks": 20,
  "cutAllowanceTicks": {
    "l": 0,
    "w": 0
  },
  "arrisMm": 0.6,
  "intendedUse": "Domestic books and objects; shelves loaded evenly. Not for climbing, not structural.",
  "loadStatement": "Self-authored: no rated load. Books and objects loaded evenly along each shelf; heaviest items on the lowest shelves.",
  "edgeTreatment": "Plywood: exposed ply edges, sanded arris 0.6 mm, lacquered with the faces. Solid timber: planed edges, 1 mm arris, oiled with the faces.",
  "fasteners": [
    {
      "id": "carcass-screw",
      "spec": "4.0 × 50 mm countersunk wood screw",
      "qtyRule": "per-joint",
      "perJoint": 3,
      "use": "Through the sides into each horizontal, 3 per joint at 25 mm from the front and back edges and centred; pilot 2.5 mm, clearance 4.5 mm; PVA glue on all butt joints."
    },
    {
      "id": "back-screw",
      "spec": "3.5 × 20 mm pan-head screw",
      "qtyRule": "back-perimeter-and-shelves",
      "centresMm": 150,
      "use": "Through the back into the sides, top, bottom and every shelf at 150 mm centres, glued."
    },
    {
      "id": "wall-bracket",
      "spec": "Steel angle bracket with fixings suited to the wall",
      "qtyRule": "fixed",
      "qty": 2,
      "use": "Under the top panel into studs, or with masonry plugs or cavity anchors suited to the wall."
    }
  ],
  "backFixing": {
    "method": "Full back (overlay or rebated) screwed to the sides, top, bottom and shelves; or per-cell backs fitted inside chosen cells, screwed to the shelf below. With an open or per-cell back the housings take the racking.",
    "spacingMm": 150,
    "rackingNote": "Open-backed offset grids depend on the divider housings and the wall fixing: square each row as it is glued."
  },
  "wallFixing": {
    "required": true,
    "method": "Two steel angle brackets under the top panel, screwed into studs or with fixings suited to the wall (masonry plugs or cavity anchors).",
    "hardware": "2 × steel angle bracket, screws and plugs to suit the wall"
  },
  "antiTip": {
    "required": true,
    "method": "Required above 1000 mm tall: wall fixing as above, plus an anti-tip strap rated for the cabinet. Load the lowest shelves first."
  },
  "warnings": {
    "maxShelfSpanMm": 800,
    "antiTipAboveMm": 1000
  },
  "assemblySteps": [
    "Glue up any solid panels listed as glue-ups first; flatten and cut to finished size.",
    "Mark the shelf datums on both sides and every divider position on each shelf from the left end.",
    "Cut the shelf housings in the sides and the divider housings in the shelves.",
    "Sand faces to 180 grit and break every arris.",
    "Glue the bottom, then each row: its dividers into the shelf below, the next shelf down over them; screw the top on.",
    "Fit the back or the cell backs, squaring the case first.",
    "Finish (two coats, de-nib between).",
    "Install: fix to the wall with two brackets and an anti-tip strap before loading."
  ],
  "markingDrilling": [
    "Mark every shelf datum (underside from the floor) on the inside face of both verticals, measured from the same (bottom) end.",
    "Screw centres at mid-thickness above each datum line, at 25 mm from the front and back edges and centred.",
    "Clearance 4.5 mm and countersink through the sides; pilot 2.5 mm into the panel edges."
  ],
  "installation": [
    "Stand the bookcase in place and check it is level and plumb; pack under the sides if the floor is uneven.",
    "Fix two angle brackets under the top panel into the wall (studs, or plugs or anchors suited to the wall).",
    "Fit the anti-tip strap before loading any shelf.",
    "Load the lowest shelves first."
  ],
  "tolerances": {
    "panelLength": 0.5,
    "panelWidth": 0.5,
    "squareness": "≤ 1 mm over the diagonal",
    "shelfDatum": 1
  },
  "backConstraint": "Each back piece fits one sheet: min(w, h) ≤ 1220 − 2a and max(w, h) ≤ 2440 − 2a, a = 2 mm; a back too wide for one sheet is split over a divider."
}
